/**
 * The `Notifications` card: whether this pool follows the fan's global
 * account settings or has its own override (Q57/NOTIF-14). The value is
 * server-owned and never inferred; while it is unknown the card shows its
 * title and nothing else. The per-pool override screen opens from the
 * `Change` action, which since ISSUE-952 sets the notifications panel on the
 * pool screen's Settings tab rather than a view of its own (ISSUE-490).
 */
import { useNotificationSettingsGetPool } from "@sportsmet/notification-sdk/private";
import { Button, Card } from "@sportsmet/ui";
import { useNavigate } from "@tanstack/react-router";
import type { ReactNode } from "react";

import { openPoolNotificationsSearch } from "../poolNotifications/poolNotificationsRoute";
import {
  NOTIFICATIONS_CARD_TITLE,
  notificationsRowBody,
} from "./poolHomeState";

export type typePoolHomeNotificationsCardProps = { poolId: string };

export const PoolHomeNotificationsCard = ({
  poolId,
}: typePoolHomeNotificationsCardProps): ReactNode => {
  const settings = useNotificationSettingsGetPool({ poolId });
  const navigate = useNavigate({ from: "/pools" });

  const body = notificationsRowBody({
    followsGlobal: settings.data?.data?.followsGlobal ?? null,
  });

  return (
    <Card
      title={NOTIFICATIONS_CARD_TITLE}
      data-testid="pool-home-notifications"
      action={
        <Button
          variant="link"
          size="sm"
          onClick={() => {
            void navigate({
              search: (prev) =>
                openPoolNotificationsSearch(prev as Record<string, unknown>),
            });
          }}
          data-testid="pool-home-notifications-open"
        >
          Change
        </Button>
      }
    >
      {body === null ? null : (
        <p
          className="text-body text-ink"
          data-testid="pool-home-notifications-body"
        >
          {body}
        </p>
      )}
    </Card>
  );
};
